module.exports = __webpack_public_path__ + "media/images/pc/plans/search_form/costume_type_kimono@2x-06a7fc7ef6f5135d16bc93e03cdd28e7.webp";